import axios from 'axios'
import { FIXTURES_ENABLED } from '@/auth/keycloak'
import { installFixtureAdapter } from '@/lib/fixtures'
import { installAuthInterceptors } from './interceptors'

/**
 * The one HTTP client. Everything goes through it; eslint forbids importing
 * axios anywhere else.
 *
 * `/api` in development (Vite proxies it to this worktree's API port), absolute
 * in production. Keeping the dev URL relative means no localhost URL can be
 * baked into a production bundle — and `frontend/deploy.sh` greps the build for
 * one anyway, because a guard you can reason about beats a convention.
 */
export const internalClient = axios.create({
  baseURL: import.meta.env.VITE_INTERNAL_API ?? '/api',
  // 35 s, not the product's 50. With statement_timeout at 8 s and
  // REQUEST_TIMEOUT at 25 s, a request still open at 35 s is not slow — it is
  // lost, and waiting longer only delays the error.
  timeout: 35_000,
})

// In fixture mode NOTHING leaves the browser: the adapter answers every request
// locally. There is no network path to production at all, which is the property
// that makes it a safe substitute for a dev-auth bypass.
if (FIXTURES_ENABLED) installFixtureAdapter(internalClient)

// The auth and tracing rules live in `interceptors.ts` so the read client and
// the write client cannot drift apart. In fixture mode nothing is installed:
// the adapter above answers every request locally and there is no token to
// attach.
if (!FIXTURES_ENABLED) installAuthInterceptors(internalClient)
